import { lazy } from "react";

// routes
export const contractRoute = { path: "/contract", name: "menu.contract", icon: "grading" };
export const contractCreateRoute = { path: `${contractRoute.path}/create`, name: "contract.add", icon: "" };
export const contractEditRoute = { path: `${contractRoute.path}/edit`, name: "contract.edit", icon: "" };
export const contractViewRoute = { path: `${contractRoute.path}/view`, name: "contract.detail", icon: "" };

// component
const Contract = lazy(() => import("../page/contract/Contract"));
const ContractList = lazy(() => import("../page/contract/ContractList"));
const ContractForm = lazy(() => import("../page/contract/form/ContractForm"));
const ContractView = lazy(() => import("../page/contract/view/ContractView"));

export const contractListRoutes = [contractRoute];
export const contractMutationRoute = [contractCreateRoute, contractEditRoute, contractViewRoute];

export const contractRoutes = {
    element: <Contract />,
    children: [
        { ...contractRoute, element: <ContractList /> },
        { ...contractCreateRoute, element: <ContractForm /> },
        { ...contractEditRoute, element: <ContractForm /> },
        { ...contractViewRoute, element: <ContractView /> },
    ]
}